// @flow

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment from 'moment'
import 'moment-timezone'
import FaCalendar from 'react-icons/lib/fa/calendar'
import {date} from '@/format'
import {appSelectors, portfoliosActions, uiActions} from '@/store'
import type {Language} from '@/types'
import {dateFormatBasedOnCountry} from '@/defaults'
import momentLocale from 'moment/min/moment-with-locales'
import './date-range-picker.css'
import {getSessionPartnerId} from '@/partnerID'

type Props = {
  l: Language,
  startDate: any,
  endDate: any,
  updateGraph: () => void,
  setGraphDates: (any) => void,
  fetchPortfolioEvents: (any) => void,
  setEventsPageNumber: (any) => void,
  translations: Object,
  langCode: string,
}
const config = (l) => {
  const currentTime = moment()
  return {
    [l('Last 7 days')]: [
      momentLocale(currentTime).subtract(7, 'days'),
      currentTime,
    ],
    [l('Last 30 days')]: [
      momentLocale(currentTime).subtract(30, 'days'),
      currentTime,
    ],
    [l('This month')]: [
      momentLocale(currentTime).startOf('month'),
      momentLocale(currentTime).endOf('month'),
    ],
    [l('Last month')]: [
      momentLocale(currentTime).subtract(1, 'month').startOf('month'),
      momentLocale(currentTime).subtract(1, 'month').endOf('month'),
    ],
  }
}

type State = {
  isTransChanged: boolean,
  index: number,
}

const copyTime = (tgtMoment, srcMoment) => {
  return tgtMoment.set({
    hour: srcMoment.get('hour'),
    minute: srcMoment.get('minute'),
    second: srcMoment.get('second'),
  })
}

export class RawDateRangePicker extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      isTransChanged: false,
      index: 0,
    }
  }
  handleEvent = (event: any, picker: any) => {
    if (event.type === 'apply') {
      const currentTime = moment()
      let {startDate, endDate, langCode} = picker
      // set current time when last 7 days or last 30 days has chosen.
      if (picker.chosenLabel === this.props.l('Last 7 days') ||
        picker.chosenLabel === this.props.l('Last 30 days')) {
        startDate = copyTime(startDate, currentTime)
        endDate = copyTime(endDate, currentTime)
      } else {
        // set start of the day and end of the day when other ranges are chosen.
        startDate = startDate.startOf('day')
        endDate = endDate.endOf('day')
      }
      this.props.setGraphDates({startDate, endDate})
      this.props.updateGraph()
      this.props.setEventsPageNumber(0)
      this.props.fetchPortfolioEvents({startDate, endDate, langCode})
    }
  }
  render = () => {
    const partnerID = getSessionPartnerId()
    return (
      <DateRangePicker
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        langCode={this.props.langCode}
        maxDate={moment()}
        ranges={config(this.props.l)}
        onEvent={this.handleEvent}
        opens="left"
        locale={{
          format: dateFormatBasedOnCountry(this.props.langCode),
          cancelLabel: this.props.l('Cancel'),
          applyLabel: this.props.l('Apply'),
          customRangeLabel: this.props.l('Custom Range'),
        }}
        key={this.state.isTransChanged ? `date-range-picker-${this.state.index++}` : undefined} // added key to remount
        // the component for translations
        applyClass={`applyBtn btn btn-sm btn-${partnerID}`}
      >
        <button className="btn btn-default selected-date-range-btn">
          <div className="daterangepicker-icon">
            <FaCalendar />
          </div>
          <div className="date-range">
            <span className="daterangepicker-date-range">
              {date(this.props.startDate, this.props.langCode)} - {date(this.props.endDate, this.props.langCode)}
            </span>
            <span className="caret"></span>
          </div>
        </button>
      </DateRangePicker>
    )
  }

  componentWillReceiveProps = (nextProps: Props) => {
    if (this.props.translations !== nextProps.translations) {
      this.setState({
        isTransChanged: true,
      })
    }
  }
}

const mapStateToProps = (state) => ({
  startDate: state.ui.graphStartDate,
  endDate: state.ui.graphEndDate,
  l: appSelectors.getL(state),
  translations: state.app.translations,
  langCode: state.app.user.preferredLanguageCode,
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawDateRangePicker)



// WEBPACK FOOTER //
// ./src/elements/date-range-picker.js